import { useState } from "react";

import { Add as AddIcon } from "@mui/icons-material";
import AddOrgazinationNewsModal from "../../../Modals/AddOrgazinationNewsModal";

const EventOrgazinationNewsAdd = (props) => {
  const { onUpdate } = props;
  const [addNews, setAddNews] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setAddNews(true);
        }}
        className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary"
      >
        <AddIcon className="m-r-5" /> Add News
      </button>
      {addNews && (
        <AddOrgazinationNewsModal
          open={addNews}
          onClose={() => {
            setAddNews(false);
          }}
          onUpdate={() => {
            setAddNews(false);
            onUpdate();
          }}
        />
      )}
    </>
  );
};

export default EventOrgazinationNewsAdd;
